import html2canvas from "html2canvas";
import moment from "moment";
import React from "react";
import html2pdf from "html2pdf.js"

// Permission rows arrive as a JSON array string, but some rows are stored
// double-encoded (a JSON string wrapping that array) or already parsed.
// Accept every shape and always return an array.
export const parsePermissionList = value => {
  let parsed = value;
  for (let i = 0; i < 2 && typeof parsed === "string"; i++) {
    try {
      parsed = JSON.parse(parsed);
    } catch (error) {
      return [];
    }
  }
  return Array.isArray(parsed) ? parsed : [];
};

export const getPermissionsByModule = (data, moduleId) => {
  const result = {};

  (Array.isArray(data) ? data : []).forEach(item => {
    const permissions = parsePermissionList(item?.permission);

    // Find the specific permission entry for the given module_id
    const permissionEntry = permissions.find(p => {
      if (typeof p === 'string') {
        const parts = p.split(',');
        return parts[0] === moduleId.toString();
      }
      return false;
    });

    const countryKey = item.country_id === 1 ? 'india' : 'uk'; // Map country_id to country name
    if (permissionEntry) {
      // Convert the permission string to an array of numbers
      const permissionArray = permissionEntry.split(',').map(Number);
      result[countryKey] = permissionArray;
    }
  });

  return result;
};


// export const checkPermissionsByModule = (data, moduleId, roleIndex) => {
//   const permission = getPermissionsByModule(data, moduleId)
//   return permission?.india[roleIndex] == 1 || (permission?.uk !== undefined && permission?.uk[roleIndex] == 1)
// };

export const checkPermissionsByModule = (data, moduleId, roleIndex) => {
  const permission = getPermissionsByModule(data, moduleId);
  const indiaPermission = Array.isArray(permission?.india) && permission.india[roleIndex] === 1;
  const ukPermission = Array.isArray(permission?.uk) && permission.uk[roleIndex] === 1;

  return indiaPermission || ukPermission;
};


export const transformGeneralData = (data) => {
  const transformArray = (arr, key, label, additionalField = null) => {
    return arr.map(item => {
      const transformedItem = {
        value: item[key],
        label: label === 'categoryname' && additionalField === 'type'
          ? `${item[label]} - ${item[additionalField]}`
          : item[label],
      };
      if (arr === data.leads) {
        transformedItem.label = `${item[label]} - (${item[key]})`;
      }
      if (additionalField && item[additionalField]) {
        transformedItem[additionalField] = item[additionalField];
      }

      return transformedItem;
    });
  };

  return {
    digital_projects: transformArray(data.digital_projects, 'id', 'project_name'),
    introducer: transformArray(data.introducer, 'id', 'company'),
    leads: transformArray(data.leads, 'id', 'company', 'lead_belongs_to'),
    proposal: transformArray(data.proposal, 'id', 'proposalsubtitle'),
    projects: transformArray(data.projects, 'id', 'project_name'),
    users: transformArray(data.users, 'id', 'name'),
    staff: transformArray(data.staff, 'id', 'name'),
    expense: transformArray(data.expense_category, "id", 'categoryname', 'type')
  };
};


export const sumTimes = (timeArray, key) => {
  const totalMinutes = timeArray?.reduce((total, item) => {
    const timeString = item[key];
    if (!timeString) return total;
    const [hours, minutes] = timeString?.split(':').map(Number);
    if (!isNaN(hours) && !isNaN(minutes)) {
      return total + (hours * 60) + minutes;
    }
    return total;
  }, 0) || 0;

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};


export const groupAndMerge = (arrays) => {
  const grouped = {}
  arrays.forEach(item => {
    const { id, related_id, related_name, related_to } = item
    const key = `${related_id}`
    if (!grouped[key]) {
      grouped[key] = {
        id,
        related_id,
        list: [],
        related_name,
        related_to
      }
    }
    grouped[key].list.push(item)
  })

  const output = Object.values(grouped)
  return output
}

export const filterData = (dataArray, filters) => {
  return dataArray.filter(item => {
    const matchesLocation = filters.location ? filters.location == item.location : true;

    const matchesAssignee = filters.assigned?.length
      ? filters.assigned.some(assignee => item.assigned?.split(',').includes(assignee.toString()))
      : true;

    const matchesStatus = filters.status?.length
      ? filters.status.includes(item.status?.trim())
      : true;

    const matchesRelated = filters.related?.length
      ? filters.related.includes(item.related?.trim())
      : true;

    return (
      matchesLocation &&
      matchesAssignee &&
      matchesStatus &&
      matchesRelated
    );
  });
};

export const filterActivityDate = (value, allData) => {
  const currentDate = moment().format("YYYY-MM-DD")
  let tempData;
  if (value == "current") {
    const filterData = allData.filter(item => {
      return item.enddate == currentDate
    })
    tempData = filterData
  } else if (value == "past") {
    const filterData = allData.filter(item => {
      return item.enddate < currentDate
    })
    tempData = filterData
  } else if (value == "future") {
    const filterData = allData.filter(item => {
      return item.enddate > currentDate
    })
    tempData = filterData
  } else if (value == "all") {
    tempData = allData
  }

  return tempData
  // const shortedData = tempData.sort(
  //   (a, b) => new Date(a.date_time) - new Date(b.date_time)
  // )
  // setFollowUp(shortedData)
}

export const customGlobalFilter = (rows, columnIds, filterValue) => {
  return rows.filter(row => {
    const rowData = row.original;
    // Iterate over all fields in row.original to check for a match
    for (const key in rowData) {
      if (
        rowData[key] &&
        rowData[key]
          .toString()
          .toLowerCase()
          .includes(filterValue.toLowerCase())
      ) {
        return true; // If any field matches, keep this row
      }
    }
    return false; // Otherwise, filter it out
  });
};

export const customGlobalTimerFilter = (rows, columnIds, filterValue) => {
  const searchString = filterValue.toLowerCase();

  const searchObject = obj => {
    for (const key in obj) {
      const value = obj[key];
      if (value) {
        if (typeof value === "object") {
          if (searchObject(value)) return true;
        } else if (value.toString().toLowerCase().includes(searchString)) {
          return true;
        }
      }
    }
    return false;
  };

  return rows.filter(row => searchObject(row.original));
};

export const captureScreenshot = (modalRef) => {
  if (modalRef.current) {
    const modalElement = modalRef.current;

    // Save the current styles that have !important (so we can restore them)
    const originalMaxHeight = window.getComputedStyle(modalElement).maxHeight;
    const originalOverflowY = window.getComputedStyle(modalElement).overflowY;

    // Temporarily apply styles to remove the max-height and allow full content capture
    modalElement.style.maxHeight = 'none'; // Remove max-height restriction
    modalElement.style.overflowY = 'visible'; // Allow overflow

    // Ensure any scrollable content is fully captured by html2canvas
    html2canvas(modalElement, {
      useCORS: true,  // Handle cross-origin resources
      allowTaint: true,  // Allow tainted content (useful for external resources)
      scrollX: 0,        // Adjust for horizontal scrolling (if any)
      scrollY: -window.scrollY,  // Adjust for vertical scroll position
      width: modalElement.scrollWidth,  // Full width of the modal content (including overflow)
      height: modalElement.scrollHeight, // Full height of the modal content (including overflow)
    }).then((canvas) => {
      const imageUrl = canvas.toDataURL("image/png");

      // Create a download link and simulate a click to download the image
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = "screenshot.png";
      link.click();

      // Restore the original styles after capturing the screenshot
      modalElement.style.maxHeight = originalMaxHeight;
      modalElement.style.overflowY = originalOverflowY;
    });
  }

};

export const getUpdatedEntries = (array, changearray) => {
  return changearray.filter(change => {
    const id = change?.split(',')[0];
    const original = array.find(item => item?.split(',')[0] === id);
    return original !== change;
  });
}
export function convertSecondsToTime(seconds) {
  // Calculate hours, minutes, and remaining seconds
  const hours = Math.floor(seconds / 3600); // 1 hour = 3600 seconds
  const minutes = Math.floor((seconds % 3600) / 60); // 1 minute = 60 seconds
  const remainingSeconds = seconds % 60; // Remaining seconds

  // Pad with leading zeros to ensure two digits for minutes and seconds
  const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;

  return formattedTime;
}

export const filterDiscrepanciesData = (data, filters) => {
  return data.filter(item => {
    const { fromDate, toDate, staffId, reported, chance, solved } = filters;

    // Filter by fromDate and toDate (if they are provided)
    const isDateValid =
      (!fromDate || fromDate === "" || new Date(item.created_at) >= new Date(fromDate)) &&
      (!toDate || toDate === "" || new Date(item.created_at) <= new Date(toDate));

    // Filter by staffId (if provided)
    const isStaffValid = !staffId || item.staff_id == staffId?.value;

    // Filter by reportedBy (if provided)
    const isReportedByValid = !reported || item.added_by == reported?.value;;

    // Filter by chance (if provided)
    const isChanceValid = chance === undefined || (chance === false ? item.time == null : item.time != null);

    // Filter by solved (if provided)
    const isSolvedValid = solved === undefined || (solved === true ? item.status == 1 : item.status != 1);

    // Dynamically apply filters based on the provided fields
    const filtersApplied =
      (fromDate || toDate ? isDateValid : true) &&
      (staffId ? isStaffValid : true) &&
      (reported ? isReportedByValid : true) &&
      (chance !== undefined ? isChanceValid : true) &&
      (solved !== undefined ? isSolvedValid : true);

    return filtersApplied;
  });
};

export function getTimeRemaining(createdAt, durationInDays) {
  const targetDate = new Date(createdAt).getTime() + durationInDays * 24 * 60 * 60 * 1000;  // Add 30 days to createdAt
  const currentTime = new Date().getTime();
  const timeLeft = targetDate - currentTime;

  // Calculate days, hours, minutes, and seconds
  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds, timeLeft };
}

export function shiftIdToEnd(array) {
  return array.map(item => {
    // Separate the components with id 1 from others
    const nonIdOneComponents = item.component.filter(c => c.id != 10);
    const idOneComponents = item.component.filter(c => c.id == 10);

    // Concatenate non-id1 components followed by the id1 components at the end
    return {
      ...item,
      component: [...nonIdOneComponents, ...idOneComponents]
    };
  });
}

export function getModuleicon(module) {
  switch (module) {
    case 'sales':
      return <i className="bx bx-tone text-primary cursor-pointer" title={module}></i>
    case 'work':
      return <i className="bx bx-task text-primary cursor-pointer" title={module}></i>
    case 'finance':
      return <i className="bi bi-bank  text-primary cursor-pointer" title={module}></i>
    case 'projects':
    default: return null
  }
}

export function filterNotificationData(array, fromDate, toDate, moduleId) {
  const fromDates = fromDate ? new Date(fromDate) : null;
  const toDates = toDate ? new Date(toDate) : null;
  return array.filter(item => {
    const itemDate = new Date(item.created_at);
    const moduleMatch = moduleId?.length != 0 ? item.module?.toLowerCase() == moduleId.value.toLowerCase() : true;
    const dateMatch = (!fromDates || itemDate >= fromDates) && (!toDates || itemDate <= toDates);
    return moduleMatch && dateMatch;
  });
}


// Digital Marketing


export function addTimes(time1, time2) {
  function convertToMinutes(timeStr) {
    if (!timeStr || typeof timeStr !== "string") {
      return 0
    }

    const [hours, minutes] = timeStr?.split(":")?.map(Number) || [];

    // Validate if hours and minutes are numbers
    if (isNaN(hours) || isNaN(minutes)) {
      return 0
    }

    return (hours * 60) + minutes;
  }
  const time1InMinutes = convertToMinutes(time1);
  const time2InMinutes = convertToMinutes(time2);
  const totalMinutes = time1InMinutes + time2InMinutes;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const resultTime = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  return resultTime;
}

export function calculateQtyWithinTime(engagedTime, estimatedTimePerQty, totalQty, availableTime) {
  // Convert time strings to minutes
  const convertToMinutes = (timeStr) => {
    const [hours, minutes] = timeStr?.split(':').map(Number);
    return hours * 60 + minutes;
  };

  // Convert engaged time and estimated time per quantity to minutes
  const engagedTimeInMinutes = convertToMinutes(engagedTime);
  const estimatedTimeInMinutes = convertToMinutes(estimatedTimePerQty);
  const availableTimeInMinutes = convertToMinutes("08:00");

  // Calculate the total time available for the activity
  const totalAvailableTime = availableTimeInMinutes - engagedTimeInMinutes;

  // Calculate the maximum quantity that can be completed
  const maxQty = Math.floor(totalAvailableTime / estimatedTimeInMinutes);

  // Return the minimum of maxQty and totalQty
  return Math.min(maxQty, totalQty);
}


export function calculateTotalTime(est, qty) {
  const [hours, minutes] = est?.split(':')?.map(Number);
  const totalMinutes = (hours * 60 + minutes) * qty;
  const resultHours = Math.floor(totalMinutes / 60);
  const resultMinutes = totalMinutes % 60;
  return `${String(resultHours)?.padStart(2, '0')}:${String(resultMinutes)?.padStart(2, '0')}`;
}

export function calculateCompleteTime(array, field = 'est_hrs') {
  let totalHours = 0;
  let totalMinutes = 0;

  array.forEach(item => {
    const time = item[field]?.split(':')?.map(Number);
    if (time) {
      const [hours, minutes] = time;
      totalHours += hours;
      totalMinutes += minutes;
    }
  });
  const extraHours = Math.floor(totalMinutes / 60);
  totalMinutes = totalMinutes % 60;
  totalHours += extraHours;
  return `${String(totalHours).padStart(2, '0')} hours ${String(totalMinutes).padStart(2, '0')} Min`;
}

export function calculateRemainingTimes(engagedTime, estimatedTimePerQty, totalQty, availableTime) {
  const convertToMinutes = (timeStr) => {
    const [hours, minutes] = timeStr?.split(':').map(Number);
    return hours * 60 + minutes;
  };
  const engagedTimeInMinutes = convertToMinutes(engagedTime);
  const estimatedTimeInMinutes = convertToMinutes(estimatedTimePerQty);
  const availableTimeInMinutes = convertToMinutes(availableTime);
  const totalTimeRequired = totalQty * estimatedTimeInMinutes;
  const remainingTime = totalTimeRequired - engagedTimeInMinutes;
  if (remainingTime <= 0) {
    return "00:00";
  }

  const timeToComplete = Math.min(remainingTime, availableTimeInMinutes);

  // Convert the remaining time back to HH:MM format
  const convertToTimeString = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
  };

  // Return the remaining time in HH:MM format
  return convertToTimeString(timeToComplete);
}

export function updateSpecificDate(array, est, dateToUpdate) {
  // Split est into hours and minutes
  const [addHours, addMinutes] = est?.split(':').map(Number);
  // Check if the date exists in the array
  if (array[dateToUpdate]) {
    const match = array[dateToUpdate].match(/>(\d{2}):(\d{2}) hrs</); // Extract current time
    if (match) {
      let [currentHours, currentMinutes] = match.slice(1).map(Number);

      // Add the time
      currentMinutes += addMinutes;
      currentHours += addHours + Math.floor(currentMinutes / 60);
      currentMinutes %= 60;
      currentHours %= 24; // Optional: Wrap around if hours exceed 24

      // Update the specific date with the new time
      const newTime = `${String(currentHours).padStart(2, '0')}:${String(currentMinutes).padStart(2, '0')} hrs`;
      array[dateToUpdate] = array[dateToUpdate].replace(/>\d{2}:\d{2} hrs</, `>${newTime}<`);
    }
  }

  return array;
}

export function FilteredArray(array1, array2) {
  return array1
    .map(item1 => {
      const match = array2?.filter(item2 => item2?.activity_id === item1?.id);
      if (match && match.length > 0) {
        const totalAssigned = match.reduce((acc, curr) => acc + (parseInt(curr.quantity) || 0), 0);
        const newQuantity = parseInt(item1.quantity) - totalAssigned;

        return {
          ...item1,
          quantity: newQuantity > 0 ? newQuantity : 0
        };
      }
      return item1;
    })
    .filter(item => parseInt(item.quantity) > 0);
}

export function FilteredArray2(array1, array2) {
  return array1
    .map(item1 => {
      const match = array2?.filter(item2 => item2?.activity_id === item1?.activity_id);
      if (match && match.length > 0) {
        const totalAssigned = match.reduce((acc, curr) => acc + (parseInt(curr.quantity) || 0), 0);
        const newQuantity = parseInt(item1.quantity) - totalAssigned;

        return {
          ...item1,
          quantity: newQuantity > 0 ? newQuantity : 0
        };
      }
      return item1;
    })
    .filter(item => parseInt(item.quantity) > 0);
}


export const updateArrayQuantities = (array1, array2) => {
  const convertToMinutes = (timeStr) => {
    const [hours, minutes] = timeStr?.split(':').map(Number);
    return hours * 60 + minutes;
  };
  const minutesToTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
  };


  return array1.map(item1 => {
    let totalDevHrsInMinutes = convertToMinutes(item1.dev_hrs);
    let totalQuantity = item1.quantity;
    array2.forEach(item2 => {
      if (item2.activity_id === item1.activity_id) {
        totalQuantity -= item2.quantity;
        totalDevHrsInMinutes -= convertToMinutes(item2.dev_hrs);
      }
    });
    if (totalQuantity > 0) {
      const newDevHrs = minutesToTime(totalDevHrsInMinutes);
      return { ...item1, quantity: totalQuantity, dev_hrs: newDevHrs };
    }
    return null;
  })
    .filter(item => item !== null);
};

export const convertToMinutes = (timeStr) => {
  const [hours, minutes] = timeStr?.split(':').map(Number);
  return hours * 60 + minutes;
};

// Helper function to convert minutes back to HH:mm format
export const minutesToTime = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

export const calculateTimeOrQuantity = (totalTime, qty, newTimePerQty = null) => {
  const totalMinutes = convertToMinutes(totalTime);

  // If new time per quantity is provided, recalculate the quantity
  if (newTimePerQty) {
    const newTimePerQtyMinutes = convertToMinutes(newTimePerQty);
    const newQuantity = Math.floor(totalMinutes / newTimePerQtyMinutes); // Round down to nearest integer
    return newQuantity;
  }

  // Otherwise, calculate the time per quantity
  const timePerQtyMinutes = totalMinutes / qty;
  return minutesToTime(timePerQtyMinutes);
};


export function updateTimeForDate(array, targetDate, additionalTime) {
  const [addHours, addMinutes] = additionalTime?.split(":").map(Number);
  return array.map((item) => {
    if (item.date == targetDate) {
      const [hours, minutes] = item.time?.split(":").map(Number);
      const totalMinutes = hours * 60 + minutes + addHours * 60 + addMinutes;
      const newHours = Math.floor(totalMinutes / 60).toString().padStart(2, "0");
      const newMinutes = (totalMinutes % 60).toString().padStart(2, "0");

      return { ...item, time: `${newHours}:${newMinutes}` };
    }
    return item;
  });
}

export function getWeekStartAndEnd() {
  const today = new Date();
  const day = today.getDay();

  let startOfWeek;
  let endOfWeek;

  // If today is Friday or Saturday, calculate the current week's start and end
  if (day === 5 || day === 6) {
    startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - (day - 5)); // Move back to Monday
    endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // Move forward to Sunday
  }
  // If today is Monday, Tuesday, Wednesday, or Thursday, calculate the last week's start and end
  else {
    startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - (day + 2)); // Move back to the previous week's Monday
    endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // Move forward to Sunday
  }

  return {
    startOfWeek: startOfWeek.toISOString().split('T')[0], // Format as YYYY-MM-DD
    endOfWeek: endOfWeek.toISOString().split('T')[0] // Format as YYYY-MM-DD
  };
}

export function calculateEndDate(startDate, durationInMonths) {
  const start = new Date(startDate); // Convert startDate to a Date object
  const end = new Date(start); // Clone the start date
  end.setMonth(end.getMonth() + Number(durationInMonths));
  return end.toISOString().split("T")[0]; // Format as YYYY-MM-DD
}

export const calculateTotalTaskTime = logs => {
  let totalSeconds = 0

  logs?.forEach(log => {
    if (!log?.start_time) return

    const start = moment(log.start_time, "YYYY-MM-DD HH:mm:ss")
    const end = log?.end_time
      ? moment(log.end_time, "YYYY-MM-DD HH:mm:ss")
      : moment() // if timer still running

    const diffInSeconds = end.diff(start, "seconds")

    if (diffInSeconds > 0) {
      totalSeconds += diffInSeconds
    }
  })

  const duration = moment.duration(totalSeconds, "seconds")

  const hours = String(Math.floor(duration.asHours())).padStart(2, "0")
  const minutes = String(duration.minutes()).padStart(2, "0")
  const seconds = String(duration.seconds()).padStart(2, "0")

  return `${hours}:${minutes}:${seconds}`
}

export const toolbarOptions = [
  [{ header: [1, 2, 3, false] }], // Headers dropdown
  ["bold", "italic", "underline", "strike"], // Formatting options
  [{ color: [] }, { background: [] }], // Text color and background color
  [{ list: "ordered" }, { list: "bullet" }], // Ordered and unordered lists
  [{ script: "sub" }, { script: "super" }], // Subscript / superscript
  [{ indent: "-1" }, { indent: "+1" }], // Indent
  [{ align: [] }], // Text alignment
  ["link", "image", "video"], // Add links, images, and videos
  ["clean"], // Clear formatting
];

export const getEncryptedData = (normalText) => {
  if (normalText) {
    try {
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(normalText),
        'MADSFARZITAPDKSJFKS'
      ).toString();

      const urlSafeEncrypted = encrypted
        .replace(/\//g, '_') // Replace / with _

      return urlSafeEncrypted;
    } catch (error) {
      // Handle any encryption errors
      console.error("Error during encryption", error);
    }
  }
};
export const getDecryptedData = (encryptedText) => {
  if (encryptedText) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedText, 'MADSFARZITAPDKSJFKS');
      const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return (data);

    } catch (error) {
      // console.log("dec Invalid Key")
      return encryptedText
    }
  } else {
    return encryptedText
  }
};

export function calculateCompleteTimeQty(array, field = 'est_hrs', qtyField = 'quantity') {
  let totalHours = 0;
  let totalMinutes = 0;

  array.forEach(item => {
    const time = item[field]?.split(':')?.map(Number);
    const qty = item[qtyField] || 1; // Default qty to 1 if not provided

    if (time) {
      const [hours, minutes] = time;
      const totalItemMinutes = (hours * 60 + minutes) * qty; // Multiply time by qty

      totalHours += Math.floor(totalItemMinutes / 60);
      totalMinutes += totalItemMinutes % 60;
    }
  });

  // Handle any overflow of minutes into hours
  const extraHours = Math.floor(totalMinutes / 60);
  totalMinutes = totalMinutes % 60;
  totalHours += extraHours;

  // Return formatted string
  return `${String(totalHours).padStart(2, '0')} hours ${String(totalMinutes).padStart(2, '0')} Min`;
}

export const adjustTime = (array, startDate, oldStart, est_time) => {
  const adjustmentInMinutes = convertToMinutes(est_time);
  return array.map(item => {
    if (item.date === oldStart) {
      const oldTimeInMinutes = convertToMinutes(item.time);
      const newTimeInMinutes = oldTimeInMinutes - adjustmentInMinutes;
      const adjustedTime = minutesToTime(newTimeInMinutes);
      return {
        ...item,
        time: adjustedTime,
      };
    }
    if (item.date === startDate) {
      const newTimeInMinutes = convertToMinutes(item.time);
      const adjustedTimeInMinutes = newTimeInMinutes + adjustmentInMinutes;
      const adjustedTime = minutesToTime(adjustedTimeInMinutes);
      return {
        ...item,
        time: adjustedTime,
      };
    }
    return item;
  });
};


export function getNextMonthStartEnd() {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const nextMonthStart = new Date(currentDate);
  nextMonthStart.setMonth(currentMonth + 1);
  nextMonthStart.setDate(1);
  const nextMonthEnd = new Date(currentDate);
  nextMonthEnd.setMonth(currentMonth + 2);
  nextMonthEnd.setDate(0);
  return {
    startDate: nextMonthStart,
    endDate: nextMonthEnd
  };
}

export function calculateTaskFit(taskTime, occupiedTime) {
  const totalMinutes = convertToMinutes('08:00'); // Total available time
  const taskMinutes = convertToMinutes(taskTime);   // Task time
  const occupiedMinutes = convertToMinutes(occupiedTime); // Occupied time
  const availableMinutes = totalMinutes - occupiedMinutes;
  const canFitMinutes = Math.min(availableMinutes, taskMinutes);
  return minutesToTime(canFitMinutes);
}
export function calculateTwoTimes(time1, time2) {
  const minutes1 = convertToMinutes(time1);
  const minutes2 = convertToMinutes(time2);
  const totalMinutes = minutes1 + minutes2;
  return minutesToTime(totalMinutes);
}

export const trimProjectName = (data) => {
  return data?.split(" ").map(word => word[0]).join("")?.toUpperCase();
}

export function calculateTimeDifference(startDateStr, endDateStr) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);
  const timeDifference = endDate - startDate;
  // if (timeDifference < 0) {
  //   return "End date cannot be earlier than start date.";
  // }
  const hours = Math.floor(timeDifference / (1000 * 60 * 60));
  const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

  // Return the formatted result
  return `${hours} hrs ${minutes} min`;
}


export const getMinDate = () => {
  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  if (currentDay >= 1 && currentDay <= 5) {
    const prevMonth = currentDate.getMonth() - 1;
    const prevMonthYear = prevMonth < 0 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
    const prevMonthFirstDate = new Date(prevMonthYear, prevMonth, 1);
    return prevMonthFirstDate.toISOString().split('T')[0];
  } else {
    const firstDateOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    return firstDateOfCurrentMonth.toISOString().split('T')[0];
  }
};


export function toggleFullscreens(mySectionRef) {
  const element = mySectionRef.current;
  if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
    // Check if the browser supports fullscreen for the specified element
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    } else if (element.msRequestFullscreen) { // For IE11
      element.msRequestFullscreen();
    }
  } else {
    // Exit fullscreen mode
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { // For IE11
      document.msExitFullscreen();
    }
  }
}
export const getUniqueByField = (array, field) => {
  const uniqueMap = new Map();

  array.forEach(item => {
    if (item[field] && !uniqueMap.has(item[field])) {
      uniqueMap.set(item[field], item);
    }
  });

  return Array.from(uniqueMap.values());
};

export const getDaysBetweenDates = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  const diffTime = Math.abs(d2 - d1);
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  return Math.ceil(diffDays) + 1;
};
export function addDaysToDate(dateStr, days) {
  if (dateStr != undefined && days != undefined) {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + days);
    const ouput = date.toISOString().split('T')[0];
    return moment(ouput).format('DD-MM-YYYY')
  }
}
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}
export function addMultiples(time1, time2, time3) {
  // Helper function to convert time in "HH:MM" format to minutes
  function timeToMinutes(time) {
    const [hours, minutes] = time?.split(':').map(Number);
    return hours * 60 + minutes;
  }

  // Helper function to convert minutes back to "HH:MM" format
  function minutesToTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const hoursStr = String(hours).padStart(2, '0');
    const minsStr = String(mins).padStart(2, '0');
    return `${hoursStr}:${minsStr}`;
  }

  // Convert the times to minutes
  const time1Minutes = timeToMinutes(time1);
  const time2Minutes = timeToMinutes(time2);
  const time3Minutes = timeToMinutes(time3);

  // Add the times together
  const totalMinutes = time1Minutes + time2Minutes + time3Minutes;

  // Convert the result back to "HH:MM" format
  return minutesToTime(totalMinutes);
}
export function convertMinutesToTimeString(minutes) {
  const totalMinutes = Math.floor(minutes); // Ensure it's an integer
  const hrs = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;

  const formattedHrs = String(hrs).padStart(2, '0');
  const formattedMins = String(mins).padStart(2, '0');

  return `${formattedHrs}:${formattedMins}`;
}
export function getTimeDifferenceInMinutes(time1, time2) {
  const [h1, m1] = time1?.split(":").map(Number);
  const [h2, m2] = time2?.split(":").map(Number);

  const date1 = new Date(0, 0, 0, h1, m1);
  const date2 = new Date(0, 0, 0, h2, m2);

  return Math.abs((date2 - date1) / 60000); // 60000 ms = 1 min
}

export function getFormattedTime(ranges = []) {
  let totalMilliseconds = 0;

  ranges.forEach(({ start, end }) => {
    const startTime = moment(start);
    const endTime = moment(end);

    if (startTime.isValid() && endTime.isValid()) {
      totalMilliseconds += endTime.diff(startTime);
    }
  });

  return moment
    .utc(totalMilliseconds)
    .format("HH:mm:ss");
}

export function parseDateTimeSlot(date, timeSlot) {
  const to24Hour = timeStr => {
    const [time, modifier] = timeStr.trim()?.split(' ');
    let [hours, minutes] = time?.split(':');
    if (modifier === 'PM' && hours !== '12') {
      hours = String(parseInt(hours) + 12);
    }
    if (modifier === 'AM' && hours === '12') {
      hours = '00';
    }
    return `${hours.padStart(2, '0')}:${minutes}`;
  };

  const [startTime, endTime] = timeSlot?.split('-');

  const start = `${date} ${to24Hour(startTime)}`;
  const end = `${date} ${to24Hour(endTime)}`;

  return { start, end };
}

export const convertTimeZone = (date, zone, fomrat) => {
  return moment(date).tz(zone).format(fomrat)
}
export function copyToClipBoard({ e, setCopy, id }) {
  if (e !== null) {
    window.navigator.clipboard.writeText(e)
    window.navigator.clipboard.writeText(e)
    setCopy({ type: id })
    setTimeout(() => {
      setCopy({
        value: "",
        type: null,
      })
    }, 1000)
  }
}

export const getInitials = (name = "") => {
  const words = name?.trim()?.split(" ");
  if (words?.length === 1) return words[0][0]?.toUpperCase() || "";
  return (words[0][0] + words[1][0]).toUpperCase();
};

export const onDownloadPdf = async (setLoading, contentRef, letterType, margins = [5, 5, 10, 10]) => {
  if (!contentRef?.current) return;

  setLoading(true);

  try {
    const fileName = `${letterType}.pdf`;
    const element = contentRef.current;
    const cloned = element.cloneNode(true);

    cloned.style.marginTop = "0px";

    const opt = {
      margin: margins,
      filename: fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 4,
        letterRendering: true,
        dpi: 300,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
      pagebreak: {
        mode: ["css", "legacy"],
      },
    };

    const pdf = await html2pdf()
      .from(cloned)
      .set(opt)
      .toPdf()
      .get("pdf");

    // modify pages
    const pageCount = pdf.internal.getNumberOfPages();
    for (let i = 2; i <= pageCount; i++) {
      pdf.setPage(i);
      pdf.internal.pageSize.height += 20;
    }

    pdf.save(fileName);
  } catch (err) {
    console.error("PDF generation failed", err);
  } finally {
    setLoading(false); // ✅ always executed
  }
};

export function calculateEndDateInvoice(startDate = new Date(), daysToAdd = 0) {
  // Ensure startDate is a Date object
  const date = new Date(startDate);

  // Add days
  date.setDate(date.getDate() + daysToAdd);

  return date ? moment(date).format('YYYY-MM-DD') : date;
}

export function numberToWords(num, currency = "INR") {
  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
  ];
  const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const currencyNames = {
    INR: { main: "Rupees", sub: "Paise" },
    GBP: { main: "GBP", sub: "Pence" },
    CAD: { main: "Canadian Dollar", sub: "Cent" },
    USD: { main: "US Dollars", sub: "Cent" },
    SGD: { main: "Singapore Dollars", sub: "Cent" },
    AUD: { main: "Australian Dollars", sub: "Cent" },
    AED: { main: "UAE Dirhams", sub: "" },
    // Add more if needed
  };

  function inWords(n) {
    n = Math.floor(n);
    if (n === 0) return "Zero";
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + inWords(n % 100) : "");
    if (n < 1000000) return inWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + inWords(n % 1000) : "");
    if (n < 1000000000) return inWords(Math.floor(n / 1000000)) + " Million" + (n % 1000000 ? " " + inWords(n % 1000000) : "");
    return inWords(Math.floor(n / 1000000000)) + " Billion" + (n % 1000000000 ? " " + inWords(n % 1000000000) : "");
  }

  const currencyInfo = currencyNames[currency] || { main: "Unit", sub: "Subunit" };

  const whole = Math.floor(num);
  const fraction = Math.round((num - whole) * 100);

  let result = inWords(whole) + " " + currencyInfo.main + (whole !== 1 ? '' : "");

  if (fraction > 0) {
    result += " and " + inWords(fraction) + " " + currencyInfo.sub + (fraction !== 1 ? "" : "");
  }

  result += " Only";

  return result;
}

export function getFinancialYear() {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const month = currentDate.getMonth(); // 0-based, so January is 0, February is 1, etc.

  // Financial year starts in April (month 3) and ends in March of the following year
  const startYear = month >= 3 ? currentYear : currentYear - 1;
  const endYear = startYear + 1;

  return `${startYear}-${endYear}`;
}
// export function calculateFinancialYearTotals(transactions, financialYearStartMonth = 3) {

//   const now = new Date();
//   const currentYear = now.getFullYear();
//   const currentMonth = now.getMonth(); // 0-based: Jan = 0, Apr = 3

//   // Determine financial year start and end
//   const fyStartYear = currentMonth >= financialYearStartMonth ? currentYear : currentYear - 1;
//   const fyStart = new Date(fyStartYear, financialYearStartMonth, 1); // e.g. April 1
//   const fyEnd = new Date(fyStartYear + 1, financialYearStartMonth, 0, 23, 59, 59, 999); // March 31, 23:59:59

//   // Filter only transactions in current financial year
//   const filtered = transactions.filter(tx => {
//     const invoiceDate = new Date(tx.invoice_date);
//     return invoiceDate >= fyStart && invoiceDate <= fyEnd;
//   });

//   // Calculate totals
//   const totalAmount = filtered.reduce((sum, tx) => {
//     const total = Number(tx.total) || 0;
//     const rate = Number(tx.exchange_rate) || 1;
//     return sum + total * rate;
//   }, 0);

//   const receivedAmount = filtered.reduce((sum, tx) => {
//     const total = Number(tx.total) || 0;
//     const balanceDue = Number(tx.balance_due) || 0;
//     const rate = Number(tx.exchange_rate) || 1;
//     return sum + (total - balanceDue) * rate;
//   }, 0);

//   const dueAmount = filtered.reduce((sum, tx) => {
//     const due = Number(tx.due_amount) || 0;
//     const rate = Number(tx.exchange_rate) || 1;
//     return sum + due * rate;
//   }, 0);

//   function formatINR(amount) {
//     return new Intl.NumberFormat('en-IN', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   }

//   return {
//     totalAmount: formatINR(Number(totalAmount)) || 0,
//     receivedAmount: formatINR(Number(receivedAmount)) || 0,
//     dueAmount: formatINR(Number(dueAmount)) || 0,
//   };
// }

export function calculateFinancialYearTotals(
  transactions,
  financialYearStartMonth = 3,
  selectedFY, // optional: "2025-2026"
  dateField = 'invoice_date'
) {
  let fyStart, fyEnd;


  console.log("transactions", transactions)

  if (selectedFY) {
    const [startYear, endYear] = selectedFY.split("-").map(Number);
    fyStart = new Date(`${startYear}-04-01`);
    fyEnd = new Date(`${endYear}-03-31 23:59:59`);
  } else {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); // 0-based

    const fyStartYear =
      currentMonth >= financialYearStartMonth ? currentYear : currentYear - 1;
    fyStart = new Date(fyStartYear, financialYearStartMonth, 1); // April 1
    fyEnd = new Date(fyStartYear + 1, financialYearStartMonth, 0, 23, 59, 59, 999); // March 31
  }

  // Filter only transactions in the selected/current financial year
  const filtered = transactions.filter(tx => {
    const invoiceDate = new Date(tx[dateField]);
    return invoiceDate >= fyStart && invoiceDate <= fyEnd;
  });

  // ... rest of your calculations remain the same
  const totalAmount = filtered.reduce((sum, tx) => {
    const total = Number(tx.total) || 0;
    const rate = Number(tx.exchange_rate) || 1;
    return sum + (total * rate);
  }, 0);

  const receivedAmount = filtered.reduce((sum, tx) => {
    const total = Number(tx.total) || 0;
    const balanceDue = Number(tx.balance_due) || 0;
    const rate = Number(tx.exchange_rate) || 1;
    return sum + (total - balanceDue) * rate;
  }, 0);

  const dueAmount = filtered.reduce((sum, tx) => {
    const due = Number(tx.due_amount) || 0;
    const rate = Number(tx.exchange_rate) || 1;
    return sum + due * rate;
  }, 0);

  function formatINR(amount) {
    return new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  return {
    totalAmount: formatINR(Number(totalAmount)) || 0,
    receivedAmount: formatINR(Number(totalAmount) - Number(dueAmount)) || 0,
    // receivedAmount: formatINR(Number(receivedAmount)) || 0,
    dueAmount: formatINR(Number(dueAmount)) || 0,
  };
}

export function calculateCommission(project, rate, quantity) {
  const amount = Number(rate) * Number(quantity)
  if (!project || !amount) return 0

  const commissionValue = Number(project.commission) || 0
  const commissionType = project.commission_structure || ""

  if (commissionType.toLowerCase() == "percentage") {
    return (commissionValue / 100) * amount
  } else if (commissionType.toLowerCase() == "fixed") {
    return commissionValue
  }
  return 0
}
